import { css } from "lit";

export const style = css`
	:host {
		display: flex;
		flex-direction: column;
		height: 100%;
		overflow: hidden;
		position: relative;
	}

	* {
		box-sizing: border-box;
	}

	.controls {
		display: flex;
		flex-direction: row;
		align-items: center;
		flex: 0;
		border-bottom: 1px solid var(--og-border-color);
		padding-bottom: 4px;
		margin: 4px;
	}

	.controls > * {
		margin-left: 2px;
		margin-right: 2px;
	}

	og-fileinput {
		flex: auto;
		height: 24px;
	}
	
	.body {
		flex: 1;
		overflow: hidden;
		position: relative;
	}

	og-grid {
		margin: 4px;
		width: 100%;
		height: 100%;
	}
	
`